import { ActionSheet } from "@repo/core/components/layout/Actionsheet";
import { ShareButtonProps } from "./types";
import { Button } from "@repo/core/components/core/Button";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { VStack } from "@gluestack-ui/themed";
import { Text } from "@gluestack-ui/themed";
import { useRef } from "react";
import { IActionsheetRefProps } from "@repo/core/components/layout/Actionsheet/types";
import { ShareItemOption } from "@repo/core/components/core/ShareButton/components/ShareItemOption";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import {
  IModalOption,
  IModalTemplateType
} from "@repo/core/components/layout/ModalTemplate/types";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { useForm } from "react-hook-form";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { Z } from "@repo/core/utils/zod.utils";
import { zodResolver } from "@hookform/resolvers/zod";

const formSchema = Z.object({
  phoneNumber: Z.string().min(11, "Informe o número de celular corretamente")
});

export const ShareButton = ({
  onSendSMSPress,
  onSharePress,
  phoneNumber,
  ...props
}: ShareButtonProps) => {
  const actionSheetRef = useRef<IActionsheetRefProps>(null);
  const alertModalRef = useRef<IModalRefProps>(null);
  const { isMobile, isTablet } = useDeviceType();

  const {
    control,
    handleSubmit,
    formState: { isValid }
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      phoneNumber
    }
  });

  const onShare = () => {
    actionSheetRef.current?.open();
  };

  const handleConfirmPhoneNumber = () => {
    alertModalRef.current?.open();
    actionSheetRef.current?.close();
  };

  const handleOnSendSMS = handleSubmit((data) => {
    onSendSMSPress?.(data?.phoneNumber || "");
    alertModalRef.current?.close();
    actionSheetRef.current?.close();
  });

  const handleShare = () => {
    onSharePress?.();
    actionSheetRef.current?.close();
  };

  const alertOptions: IModalOption[] = [
    {
      label: "Enviar",
      type: isValid ? IModalTemplateType.success : IModalTemplateType.info,
      isDisabled: !isValid,
      onPress: handleOnSendSMS
    }
  ];

  return (
    <>
      <Button
        text={isMobile || isTablet ? "Compartilhar" : "Salvar PDF"}
        onPress={onShare}
        action="darker-secondary"
        variant="outline"
        leftIcon={{
          name: isMobile || isTablet ? "share-up" : "arrow-down-line",
          size: 20
        }}
        {...props}
      />
      <ActionSheet ref={actionSheetRef}>
        <VStack w="$full" p="$2" mb="$2">
          <VStack mb="$4">
            <Text fontSize="$md" fontWeight={500} color="$textLight600">
              Compartilhar
            </Text>
          </VStack>

          <VStack>
            <ShareItemOption
              icon="sms"
              label="Enviar por SMS"
              onPress={handleConfirmPhoneNumber}
            />
            <ShareItemOption
              icon={isMobile || isTablet ? "share" : "arrow-down-line"}
              label={isMobile || isTablet ? "Outras opções" : "Salvar PDF"}
              onPress={handleShare}
            />
          </VStack>
        </VStack>
      </ActionSheet>
      <AlertModal
        ref={alertModalRef}
        icon="sms"
        iconColor="$primary600"
        maxWidth={470}
        title="Informe o número"
        options={alertOptions}
      >
        <InputControlled
          control={control}
          mask="cellphone"
          name="phoneNumber"
          label="Celular"
          isRequired
          keyboardType="number-pad"
          rightIcon={{
            name: "phone"
          }}
        />
      </AlertModal>
    </>
  );
};
